import { createFileRoute } from "@tanstack/react-router";
import { CanvasPage } from "../features/canvas/CanvasPage";

// ?page=<id> opens that page: how a Tread's composer shortcut opens what it carries.
// ?fromFile=<file>&c=<Tread> makes a page from a markdown file sent to the Tread and
// opens it (TANK's "Add to Atlas" offer).
export const Route = createFileRoute("/w/$ws/canvas")({
  component: () => {
    const { page, fromFile, c } = Route.useSearch();
    return (
      <CanvasPage
        openPageId={page}
        fromFile={fromFile && c ? { fileId: fromFile, channelId: c } : undefined}
      />
    );
  },
  validateSearch: (s: Record<string, unknown>): { page?: string; fromFile?: string; c?: string } => ({
    page: typeof s.page === "string" ? s.page : undefined,
    fromFile: typeof s.fromFile === "string" ? s.fromFile : undefined,
    c: typeof s.c === "string" ? s.c : undefined,
  }),
});
